import { createContext, useContext, useEffect, useState } from 'react'
import { api, setToken, clearToken, getToken } from '../data/api'

const AuthCtx = createContext(null)

function getStoredUser() {
  try {
    const u = localStorage.getItem('sa_user')
    return u ? JSON.parse(u) : null
  } catch { return null }
}

function storeUser(user) {
  localStorage.setItem('sa_user', JSON.stringify(user))
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => getStoredUser())

  // Validate token on app load — kicks out stale sessions immediately on refresh
  useEffect(() => {
    if (!getToken()) return
    api.get('/api/users/me').then(data => {
      storeUser(data)
      setUser(data)
    }).catch(() => {})
  }, [])

  async function login(credentials) {
    const data = await api.post('/api/auth/login', credentials)
    setToken(data.token)
    storeUser(data.user)
    setUser(data.user)
    return data.user
  }

  async function register(data) {
    const res = await api.post('/api/auth/register', data)
    // Returns { message, userId } — OTP sent, no token yet
    return res
  }

  async function verifyOTP(userId, otp) {
    const res = await api.post('/api/auth/verifyOtp', { userId, otp })
    // Admin: no token yet (pending approval) — just return response
    if (res.token) {
      setToken(res.token)
      storeUser(res.user)
      setUser(res.user)
    }
    return res
  }

  async function resendOTP(userId) {
    return api.post('/api/auth/resendOtp', { userId })
  }

  function updateUser(updated) {
    const merged = { ...user, ...updated }
    storeUser(merged)
    setUser(merged)
  }

  async function logout() {
    try { await api.post('/api/auth/logout') } catch {}
    clearToken()
    localStorage.removeItem('sa_user')
    setUser(null)
  }

  return (
    <AuthCtx.Provider value={{ user, login, register, verifyOTP, resendOTP, logout, updateUser, isAuthenticated: !!user }}>
      {children}
    </AuthCtx.Provider>
  )
}

export const useAuth = () => useContext(AuthCtx)
